import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

export default function CallbackPage() {
  const { handleCallback } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [processed, setProcessed] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    if (processed) return;

    const processCallback = async () => {
      try {
        //console.log('Callback processing - once only');
        setProcessed(true);
        
        await handleCallback();
        //console.log('Callback successful - navigating');
        
        // Always redirect to welcome page first
        navigate('/welcome', { replace: true });
        
      } catch (error) {
        //console.error('Callback failed:', error);
        
        if (error.message.includes('No matching state')) {
          Object.keys(localStorage).forEach(key => {
            if (key.startsWith('oidc.')) {
              localStorage.removeItem(key);
            }
          });
          //console.log('Redirecting to login due to state mismatch');
          window.location.href = '/login';
        } else {
          setError(`Erro na autenticação: ${error.message}`);
        }
      }
    };

    processCallback();
  }, [processed, handleCallback, navigate, location]);

  if (error) {
    return (
      <div style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontFamily: 'sans-serif',
        color: '#fff',
        flexDirection: 'column',
        gap: '20px'
      }}>
        <div>{error}</div>
        <button 
          onClick={() => window.location.href = '/login'}
          style={{
            padding: '10px 20px',
            backgroundColor: '#007bff',
            color: 'white',
            border: 'none',
            borderRadius: '4px',
            cursor: 'pointer'
          }}
        >
          Voltar ao Login
        </button>
      </div>
    );
  }

  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      fontFamily: 'sans-serif',
      color: '#fff'
    }}>
      <div>A processar autenticação...</div>
    </div>
  );
}